var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuggestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.3,
    height: 12.418,
    viewBox: "0 0 13.3 12.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Suggestion",
    transform: "translate(-4 -6.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11251",
    "data-name": "Path 11251",
    d: "M14.876,13H4.946A.933.933,0,0,0,4,13.918v6.416a.93.93,0,0,0,.943.916H7.916a.216.216,0,0,1,.177.091l1.643,2.4a.214.214,0,0,0,.35,0l1.653-2.4a.216.216,0,0,1,.177-.091h2.963a.93.93,0,0,0,.943-.916V13.918A.933.933,0,0,0,14.876,13ZM6.463,14.662H9.419a.493.493,0,0,1,0,.985H6.463a.493.493,0,1,1,0-.985ZM10.9,19.588H6.463a.493.493,0,0,1,0-.985H10.9a.493.493,0,1,1,0,.985Zm2.463,0h-.985a.493.493,0,0,1,0-.985h.985a.493.493,0,0,1,0,.985Zm0-1.97h-6.9a.493.493,0,1,1,0-.985h6.9a.493.493,0,0,1,0,.985Z",
    transform: "translate(0 -4.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11252",
    "data-name": "Path 11252",
    d: "M20.876,6.58H10.946A.933.933,0,0,0,10,7.5v.17h9.4A1.427,1.427,0,0,1,20.837,9.08v5.751a.932.932,0,0,0,.985-.916V7.5A.933.933,0,0,0,20.876,6.58Z",
    transform: "translate(-4.522)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestion);
export default __webpack_public_path__ + "static/media/Suggestion.c113b0ac8cd4e3f8b1f055bc57f69abb.svg";
export { ForwardRef as ReactComponent };